import { Progress } from "@/components/ui/progress";

export function ScanProgress({ current, total }) {
  const pct = Math.round(((current + 1) / total) * 100);
  const stepLabel = String(current + 1).padStart(2, "0");
  const totalLabel = String(total).padStart(2, "0");
  return (
    <div className="mb-10" data-testid="scan-progress">
      <div className="flex justify-between items-baseline mb-3">
        <span className="font-mono text-sm text-foreground">{stepLabel} / {totalLabel}</span>
        <span className="font-mono text-xs text-muted-foreground uppercase tracking-[0.16em]">{pct}% complete</span>
      </div>
      <Progress value={pct} />
    </div>
  );
}
